export default __webpack_public_path__ + "static/media/mlanalyzing.dcf30373.gif";